// Event schema registry (05 §7, SYNC-07/08): every outbox event carries `schemaVersion`; the cloud accepts the
// current version and the two before it (N-2) and upcasts older payloads before projecting. Breaking changes
// bump CURRENT_EVENT_SCHEMA and add an upcaster step; additive changes do not.
import { z } from 'zod';
import { eventEnvelopeSchema } from './sync.js';
/** The event schema version node-api writes today. */
export const CURRENT_EVENT_SCHEMA = 1;
/** Oldest schema version the cloud still processes (N-2). Older events are stored raw and flagged. */
export const MIN_SUPPORTED_EVENT_SCHEMA = Math.max(1, CURRENT_EVENT_SCHEMA - 2);
/** `UPCASTERS[v]` turns a version-v payload into version v+1. Chained up to CURRENT_EVENT_SCHEMA. */
export const UPCASTERS = {
// example shape for the first breaking change:
// 1: { ReservationCreated: (p) => ({ ...p, rooms: p['rooms'] ?? [] }), '*': (p) => p },
};
export function upcastEvent(event) {
    if (event.schemaVersion > CURRENT_EVENT_SCHEMA)
        return { ok: false, reason: 'future_version' };
    if (event.schemaVersion < MIN_SUPPORTED_EVENT_SCHEMA)
        return { ok: false, reason: 'unsupported_version' };
    let payload = event.payload;
    for (let v = event.schemaVersion; v < CURRENT_EVENT_SCHEMA; v++) {
        const step = UPCASTERS[v];
        const fn = step?.[event.eventType] ?? step?.['*'];
        if (fn)
            payload = fn(payload);
    }
    return { ok: true, event: { ...event, schemaVersion: CURRENT_EVENT_SCHEMA, payload } };
}
/** Wire shape of the batch the relay posts (05 §6): ≤ 200 events, sequence-ordered. */
export const outboxBatchSchema = z.object({
    nodeVersion: z.string().min(1).max(32),
    events: z.array(eventEnvelopeSchema).min(1).max(200),
});
export const outboxBatchAckSchema = z.object({
    ackedUpToSequence: z.number().int().nonnegative(),
    accepted: z.number().int().nonnegative(),
    duplicates: z.number().int().nonnegative(),
    /** MT-03: events stamped with another property were acked (so the node stops resending) but not stored */
    rejected: z.number().int().nonnegative().default(0),
    serverTime: z.iso.datetime(),
    nextPollHintSeconds: z.number().int().positive(),
});
//# sourceMappingURL=events.js.map